import React,{useState} from 'react'
export const Main= () => {
 return <div className='text-[12px] m-1'>This is main page.</div>
}
export const Page1= () => {
 return <div className='text-[12px] m-1'>This is page1.</div>
}
export const Page2= () => {
 return <div className='text-[12px] m-1'>This is page2.</div>
}
export default function PagesTab() {
    const pages=[{ttl:'main',page:<Main/>},{ttl:'page1',page:<Page1/>},{ttl:'page2',page:<Page2/>}]
    const [selectedPage, setSelectedPage] = useState('main')
    return(
        <>
        <div className='flex text-[10px]'>
        <button onClick={()=>setSelectedPage('main')} className={`${selectedPage==='main'?'text-gray-800':'text-gray-400'} mr-1`}>main</button>
        <button onClick={()=>setSelectedPage('page1')} className={`${selectedPage==='page1'?'text-gray-800':'text-gray-400'} mr-1`}>page1</button>
        <button onClick={()=>setSelectedPage('page2')} className={selectedPage==='page2'?'text-gray-800':'text-gray-400'}>page2</button>
        </div>
        {pages.map((x,i)=>x.ttl===selectedPage&&<div key={i}>{x.page}</div>)}
        </>
    )
}